// Ported verbatim from the LeadMailer Design System (components/forms/Switch.jsx).
import React from 'react'

export interface SwitchProps {
  checked?: boolean
  onChange?: (checked: boolean) => void
  label?: React.ReactNode
  disabled?: boolean
  style?: React.CSSProperties
}

export function Switch({ checked, onChange, label, disabled, style }: SwitchProps) {
  return (
    <label className="tap"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontSize: 'var(--text-base)',
        color: 'var(--text-primary)',
        minHeight: 24,
        ...style,
      }}
      onClick={() => !disabled && onChange && onChange(!checked)}
    >
      <span
        style={{
          width: 34,
          height: 20,
          flex: 'none',
          borderRadius: 'var(--radius-full)',
          background: checked ? 'var(--accent)' : 'var(--border-strong)',
          position: 'relative',
          transition: 'background var(--dur-base) var(--ease-out)',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 2,
            left: checked ? 16 : 2,
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: 'var(--shadow-xs)',
            transition: 'left var(--dur-base) var(--ease-out)',
          }}
        />
      </span>
      {label && <span>{label}</span>}
    </label>
  )
}
